import { observer } from "mobx-react-lite";
import React, { Fragment, useEffect, useState } from "react";
import { useStore } from "../../app/stores/store";
import { Button, Header, Icon, Segment } from "semantic-ui-react";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import "./Operaciones_style.css";
import EditIcon from "@material-ui/icons/Edit";
import PendienteIcon from "@material-ui/icons/AccessTime";
import ListIcon from "@material-ui/icons/ViewList";
import Check from "@material-ui/icons/Check";
import Anular from "@material-ui/icons/Cancel";
import { ExoneracionesModFormValues } from "../../app/models/ExoneracionesMod";
import { IconButton, makeStyles, withStyles } from "@material-ui/core";
import UpdateExoneracion from "../Modals/UpdateExoneracion";
import VerExoneraciones from "../Modals/VerExoneraciones";
import ExoneracionRechazada from "../Modals/ExoneracionRechazada";
import ReactTooltip from "react-tooltip";
import { OverlayTrigger, Popover, Tooltip } from "react-bootstrap";

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: "14px",

    color: "rgb(255 255 255 / 87%)",
  },
}));

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#0489c0",
      border: "3px solid white",
      color: "rgb(255 255 255 / 87%)",
    },

    "&:nth-of-type(even)": {
      backgroundColor: "#15b2e7",
      border: "3px solid white",
      color: "rgb(255 255 255 / 87%)",
    },
  },
}))(TableRow);

const StyledTableHead = withStyles((theme) => ({
  root: {
    fontFamily: "Gotham-Bold",

    "&:nth-of-type(odd)": {
      backgroundColor: "#15b2e7",
      border: "3px solid white",
      color: "rgb(255 255 255 / 87%)",
    },
  },
}))(TableHead);

export default observer(function TablaNoti() {
  const classes = useStyles();
  const {
    userStore: { user, logout, isLoggedIn, roles },
    CuotasStore,
    ExoneracionesStore,
    modalStore,
  } = useStore();
  const { loadCuotas } = CuotasStore;
  const { dpiByCodigo, exoneracionDetail, loadExonDetail } = ExoneracionesStore;
  const { CCTOperacionStore, CuentaDPIStore } = useStore();
  const {
    createCCTOperacion,
    getTransacciones,
    TransaccionByCodigo,
    TransaccionRegistry,
    personaDPI,
    kk,
    inputPersona,
    CCTCuentaByCodigo,
  } = CCTOperacionStore;

  return (
    <div id="contenedor_busqueda_movimiento">
      <TableContainer>
        <Table aria-label="a dense table" className={classes.root}>
          <StyledTableHead>
            <TableRow style={{ color: "white" }}>
              <TableCell align="center" className={classes.root}>
                <b>No.</b>
              </TableCell>
              <TableCell align="center" className={classes.root}>
                <b>Solicitado por</b>
              </TableCell>
              <TableCell align="center" className={classes.root}>
                <b>Modificado por</b>
              </TableCell>
              <TableCell align="center" className={classes.root}>
                <b>Fecha de solicitud</b>
              </TableCell>
              <TableCell align="center" className={classes.root}>
                <b>Fecha modificacion</b>
              </TableCell>
              <TableCell align="left" className={classes.root}>
                <b>Razón de solicitud</b>
              </TableCell>
              <TableCell align="center" className={classes.root}>
                <b>Estado</b>
              </TableCell>
              <TableCell align="center" className={classes.root}>
                <b></b>
              </TableCell>
            </TableRow>
          </StyledTableHead>
          <TableBody>
            {dpiByCodigo.map((personai) => {
              return (
                   <StyledTableRow  key={`edits_${personai.idcontrol}`}>
                    <TableCell
                      component="th"
                      scope="row"
                      align="center"
                      className={classes.root}                    
                    >
                      {personai.idcontrol}
                    </TableCell>
                    <TableCell align="center" className={classes.root}>
                      {personai.solicitado_por}
                    </TableCell>
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip
                          style={{
                            cursor: "hand",
                            background: "white",
                            color: "#000",
                            marginTop: "20px",
                            padding: "10px",
                            position: "relative",
                            top: "50%",
                            left: "50%",
                            transform: "translateX(50%) translateY(50%)",
                          }}
                          id="tooltip-disabled"
                        >
                          {personai.nombreCompletoAprobadopor}
                        </Tooltip>
                      }
                    >
                      <TableCell
                        style={{ cursor: "hand" }}
                        className={classes.root}
                      >
                        {personai.aprobado_por}
                      </TableCell>
                    </OverlayTrigger>

                    <TableCell align="center" className={classes.root}>
                      {personai.fecha_de_solicitud
                        .split("-")
                        .slice(-1)
                        .join(" ")
                        .split("T")
                        .slice(0, -1) +
                        "/" +
                        personai.fecha_de_solicitud
                          .split("-")
                          .slice(1, -1)
                          .join(" ") +
                        "/" +
                        personai.fecha_de_solicitud
                          .split("-")
                          .slice(0, 1)
                          .join(" ")}{" "}
                    </TableCell>

                    <TableCell align="center" className={classes.root}>
                      {personai.fecha_de_aprobacion == null
                        ? null
                        : personai.fecha_de_aprobacion
                            .split("-")
                            .slice(-1)
                            .join(" ")
                            .split("T")
                            .slice(0, -1) +
                          "/" +
                          personai.fecha_de_aprobacion
                            .split("-")
                            .slice(1, -1)
                            .join(" ") +
                          "/" +
                          personai.fecha_de_aprobacion
                            .split("-")
                            .slice(0, 1)
                            .join(" ")}
                    </TableCell>

                    <TableCell align="left" className={classes.root}>
                      {personai.razon_de_solicitud}
                    </TableCell>
                    <TableCell align="center" className={classes.root}>
                      {personai.estado}
                    </TableCell>

                    {roles()?.map((rol: any) => {
                      if (rol == "Cargo Pagos") {
                        if (personai.estado == "APROBADO") {
                          return (
                            <TableCell align="center" className={classes.root} key={`editss_${personai.idcontrol}`}>
                              <IconButton
                               
                                aria-label="list"
                                onClick={() => {
                                  modalStore.openModal(
                                    <VerExoneraciones
                                      idControl={personai.idcontrol}
                                      dpis={personai.alumno}
                                    />,
                                    'mini'
                                  );
                                }}
                              >
                                {" "}
                                <Check
                                  style={{
                                    background: "",
                                    fontFamily: "Gotam-Bold",
                                    borderRadius: "50%",
                                    color: "#FFFFFF",
                                  }}
                                />
                              </IconButton>
                            </TableCell>
                          );
                        } else if (personai.estado == "RECHAZADO") {
                          return (
                            <TableCell align="center" className={classes.root}  key={`edi_${personai.idcontrol}`}>
                              <IconButton
                             
                                aria-label="list"
                                onClick={() => {
                                  modalStore.openModal(
                                    <ExoneracionRechazada
                                      idControl={personai.idcontrol}
                                      dpis={personai.alumno}
                                    />,
                                    'mini'
                                  );
                                }}
                              >
                                {" "}
                                <Anular
                                  style={{
                                    background: "#FF0000",
                                    borderRadius: "50%",
                                    color: "#FFFFFF",
                                  }}
                                />
                              </IconButton>
                            </TableCell>
                          );
                        }
                        return (
                          <TableCell align="center" className={classes.root}  key={`ed_${personai.idcontrol}`}>
                            <IconButton
                           
                              aria-label="edit"
                              onClick={() => {
                                modalStore.openModal(
                                  <UpdateExoneracion
                                    idControl={personai.idcontrol}
                                    dpis={personai.alumno}
                                  />,
                                  'mini'
                                );
                              }}
                            >
                              {" "}
                              <PendienteIcon
                                style={{
                                  background: "",
                                  borderRadius: "50%",
                                  color: "#FFFFFF",
                                }}
                              />
                            </IconButton>
                          </TableCell>
                        );
                      }
                    })}
                  </StyledTableRow>
                
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <OverlayTrigger
        overlay={<Tooltip id="tooltip-disabled">Tooltip!</Tooltip>}
      >
        <span className="d-inline-block">
          {/* <Button disabled style={{ pointerEvents: 'none' }}>
                     Disabled button
                        </Button> */}
        </span>
      </OverlayTrigger>
    </div>
  );
});
